import React from "react";
import { StyleSheet, View } from "react-native";
import { Helmet } from "react-helmet";

import { EventCountPanel } from "./Components/Events/EventCountPanel";
import PeopleBar from "./Components/Members/PeopleBar";
import { EventFeed } from "./Components/Events/EventFeed";

import PageLayout from "@/Components/Layouts/Web/PageLayout";

const LandingPage: React.FC = () => {
  const styles = StyleSheet.create({
    content: {
      flexDirection: "row",
      gap: 16,
    },
  });
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"Kai Social"}</title>
        <meta name="description" content="Gay Social Community" />
        <meta name="agd-partner-manual-verification" />
        <link rel="canonical" href="https://getkaiapp.com" />
      </Helmet>
      <PageLayout>
        <View style={styles.content}>
          <EventCountPanel />
          <EventFeed />
          <PeopleBar />
        </View>
      </PageLayout>
    </>
  );
};

export default LandingPage;
